import { useAppDispatch } from "@/app/hooks";
import { setHiddenMapKeyColors } from "@/features/auth/interactiveSurveySlice";
import { getInteractiveToken } from "@/services/interactiveSurveyAuth";
import { useEffect } from "react";
import { useParams } from "react-router";

export const getMapKeyStorageKey = (surveyId: string): string => {
  const token = getInteractiveToken();
  return `mapKeyVisibility_${surveyId}_${token ?? "default"}`;
};

/**
 * Loads persisted map key visibility from localStorage into Redux once per mount.
 * Call this in a single parent component (e.g. InteractiveSurveyLayout) so the
 * dispatch runs exactly once per survey session, not once per child component.
 */
export const useMapKeyVisibility = () => {
  const { surveyId } = useParams<{ surveyId: string }>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!surveyId) return;
    try {
      const stored = localStorage.getItem(getMapKeyStorageKey(surveyId));
      if (stored) {
        dispatch(setHiddenMapKeyColors(JSON.parse(stored) as string[]));
      }
    } catch {
      console.warn("Failed to load map key visibility from storage");
    }
  }, [surveyId, dispatch]);
};
